import type { IconData } from '@stacksjs/iconify-core'

export const candle: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M38 46V35.77c0-2.002-.07-3.63-.166-4.917c-.17-2.282-2.104-3.864-4.39-3.785c-6.457.223-13.108.991-19.235 2.223c-2.187.44-3.862 2.144-4.047 4.367A50 50 0 0 0 10 37.815V46M23.034 2.02c.56-.13 1.013.373.989.948c-.101 2.454.062 6.43 1.919 8.435c.389.42 1.022.536 1.487.202c1.11-.796 1.865-2.526 2.365-4.234c.223-.76 1.178-1.038 1.671-.419C32.919 8.773 34 11.04 34 13.754c0 5.694-4.477 8.248-10 8.248s-10-2.554-10-8.248c0-5.752 4.863-9.498 7.806-11.24c.39-.23.804-.394 1.228-.493Z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default candle
